import React from 'react';
import { useAppSettings, DEFAULT_SECTIONS } from '../context/AppSettingsContext';
import { useJazyk } from '../context/LanguageContext';
import { nazevSekce } from '../lib/nazvySekci';

/**
 * Nadpis sekce — barvu i název bere z nastavení administrace.
 *
 * Název se překládá, dokud ho správkyně nepřejmenovala; pak zůstává její.
 * Rozhodnutí je v `lib/nazvySekci.js`, ať platí stejné pravidlo i v liště
 * a na dlaždicích na domovské stránce.
 */
export const SectionHeader = ({
  sectionKey,
  klicTitulku,
  klicPodtitulku,
  defaultTitle,
  defaultSubtitle,
  defaultColor = '#8A7CFF',
  className = '',
}) => {
  const { sections, markerColors } = useAppSettings();
  const { t } = useJazyk();
  const cfg = sections?.[sectionKey] || {};
  const seed = DEFAULT_SECTIONS[sectionKey] || {};

  // Barva: markerColors[sectionKey] > sections[sectionKey].color > defaultColor
  const color = markerColors?.[sectionKey] || cfg.color || defaultColor;
  const title = klicTitulku
    ? nazevSekce(t, cfg.title, klicTitulku, seed.title)
    : (cfg.title || defaultTitle);
  const subtitle = klicPodtitulku
    ? nazevSekce(t, cfg.subtitle, klicPodtitulku, seed.subtitle)
    : (cfg.subtitle || defaultSubtitle);

  return (
    <div className={`mb-6 ${className}`}>
      <h1 className="font-serif text-3xl sm:text-4xl font-semibold text-bloom-text/80 mb-2 flex items-center">
        <span className="section-marker" style={{ background: color }} />
        {title}
      </h1>
      {subtitle && <p className="text-bloom-sub">{subtitle}</p>}
    </div>
  );
};
